import { Component, Inject, OnInit } from '@angular/core';
import { AngularFireAnalytics } from '@angular/fire/compat/analytics';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-welcome-dialog',
  templateUrl: './welcome-dialog.component.html',
  styleUrls: ['./welcome-dialog.component.scss'],
})
export class WelcomeDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public welcomeDialogData: any,
    public welcomeDialogRef: MatDialogRef<WelcomeDialogComponent>,
    private analytics: AngularFireAnalytics,
  ) {}

  ngOnInit() {
    this.welcomeDialogRef.disableClose = true;
    this.welcomeDialogRef.addPanelClass('welcome-dialog');
  }

  openLinkSameTab(url: any) {
    window.open(url, '_self');
    this.welcomeDialogRef.close();
  
  }

  logEvent(data:any){
    if(data?.action10?.resultType === 'ICSE10'){
      this.analytics.logEvent('ICSE_pre_login', {
        category: 'ICSE_10',
        action: 'clicked',
        label: 'ICSE 10th Result',
      });
    } else  if(data?.action12?.resultType === 'ICSE12'){
      this.analytics.logEvent('ICSE_pre_login', {
        category: 'ICSE_12',
        action: 'clicked',
        label: 'ICSE 12th Result',
      });
    } else  if(data?.action10?.resultType === 'CBSE10'){
      this.analytics.logEvent('CBSE_pre_login', {
        category: 'CBSE_10',
        action: 'clicked',
        label: 'CBSE 10th Result',
      });
    } else  if(data?.action12?.resultType === 'CBSE12'){
      this.analytics.logEvent('CBSE_pre_login', {
        category: 'CBSE_12',
        action: 'clicked',
        label: 'CBSE 12th Result',
      });
    } else if(data?.action10?.resultType === 'TNSB10'){
      this.analytics.logEvent('TNSB_pre_login', {
        category: 'TNSB_10',
        action: 'clicked',
        label: 'TNSB 10th Result',
      });
    }  else if(data?.action10?.resultType === 'RBSE10' && data?.action10?.isActive){
      console.log("RBSE_10");
      this.analytics.logEvent('RBSE_pre_login', {
        category: 'RBSE_10',
        action: 'clicked',
        label: 'RBSE 10th Result',
      });
    }  else if(data?.action12?.resultType === 'RBSE12' && data?.action12?.isActive){
      console.log("RBSE_12");
      this.analytics.logEvent('RBSE_pre_login', {
        category: 'RBSE_12',
        action: 'clicked',
        label: 'RBSE 12th Result',
      });
    }  else if(data?.action10?.resultType === 'UPMSP10' && data?.action10?.isActive){
      this.analytics.logEvent('UPMSP_pre_login', {
        category: 'UPMSP_10',
        action: 'clicked',
        label: 'UPMSP 10th Result',
      });
    }  else if(data?.action12?.resultType === 'UPMSP12' && data?.action12?.isActive){
      this.analytics.logEvent('UPMSP_pre_login', {
        category: 'UPMSP_12',
        action: 'clicked',
        label: 'UPMSP 12th Result',
      });
    } else if(data?.action10?.resultType === 'MSBS10' && data?.action10?.isActive){
      this.analytics.logEvent('MSBS_pre_login', {
        category: 'MSBS_10',
        action: 'clicked',
        label: 'MSBS 10th Result',
      });
    } else if(data?.action12?.resultType === 'MSBS12' && data?.action12?.isActive){
      console.log("RBSE_12");
      this.analytics.logEvent('MSBS_pre_login', {
        category: 'MSBS_12',
        action: 'clicked',
        label: 'MSBS 12th Result',
      });
    } else if(data?.action12?.resultType === 'MSBS12' && data?.action12?.isActive){
      console.log("MSBS_12");
      this.analytics.logEvent('MSBS_pre_login', {
        category: 'MSBS_12',
        action: 'clicked',
        label: 'MSBS 12th Result',
      });
    } else if(data?.action12?.resultType === 'JK12' && data?.action12?.isActive){
      this.analytics.logEvent('JK_pre_login', {
        category: 'JK_12',
        action: 'clicked',
        label: 'JK 12th Result',
      });
    } else if(data?.action12?.resultType === 'OBSE12' && data?.action12?.isActive){
      console.log("OBSE_12");
      this.analytics.logEvent('OBSE_pre_login', {
        category: 'OBSE_12',
        action: 'clicked',
        label: 'OBSE 12th Result',
      });
    }     
  }
}
